import 'corejs-typeahead';
import addressAutocomplete from './address_google_autocomplete';

const AUTO_COMPLETION_ENABLED = window.__address_auto_complete ? true : false;

$(() => {
  $('[data-form="address"]').each((i, item) => {
    const $item = $(item);
    const address1Section = $item.find('[data-form-section="address1"]');
    const countrySection = $item.find('[data-form-section="country"]');
    const afterCountry = $item.find('[data-form-section="after-country"]');
    const company = $item.find('[name$="company"]');
    const companyContainer = company.closest('.form-group');
    const country = $item.find('[name$="country"]');
    const address1 = $item.find('[name$="address1"]');
    const address2 = $item.find('[name$="address2"]');
    const city = $item.find('[name$="city"]');
    const subdivisionLabel = $item.find('[for$="subdivision"]');
    const postalCode = $item.find('[name$="postal_code"]');
    const postalCodeLabel = $item.find('[for$="postal_code"]');

    let citySuggestions = [];

    function getSubdivision() {
      const subdivision = $item.find('[name$="subdivision"]');
      if (subdivision.prop("tagName") == "SELECT") {
        return subdivision.children("option").filter(":selected").text();
      } else {
        return subdivision.val();
      }
    }

    function setSubdivision(value) {
      const subdivision = $item.find('[name$="subdivision"]');
      if (subdivision.prop("tagName") == "SELECT") {
        const options = subdivision.find('option').filter((i, option) => $(option).text().toLowerCase() == value.toLowerCase());
        if (options.length) {
          subdivision.val(options.attr('value') || options.text());
        } else {
          subdivision.val(value);
        }
      } else {
        subdivision.val(value);
      }
    }

    function setCountry(value) {
      if (value === 'United States') {
        value = 'United States of America';
      }
      const options = country.find('option').filter((i, option) => $(option).text().toLowerCase() == value.toLowerCase());
      if (country.length) {
        country.val(options.attr('value') || options.text());
      } else {
        country.val('');
      }
      country.trigger('change');
    }

    // Jump to address 2 so the places autocomplete disappears
    address1.on('change', event => {
      if (address1.is(":focus")) {
        address2.focus();
        address2.select();
      }
    });

    if (AUTO_COMPLETION_ENABLED) {
      addressAutocomplete(address1[0], place => {
        address1.val(place.address || '');
        city.val(place.city || '');
        postalCode.val(place.postal_code || '');
        setSubdivision(place.state);
        setCountry(place.country);
        address2.attr('placeholder', 'Enter apt, suite, unit, floor, etc.');
        address2.focus();

        postalCode.css('display', 'inline-block');
        postalCode.parent().find(".place-autocomplete-warning").remove();
        postalCode.parent().append('<span class="place-autocomplete-warning mb-2 ml-2 text-success">Is the rest of this correct?</span>').fadeIn(1000);});

      // Since we are auto-completing, move the country box after the address
      $(afterCountry).insertBefore(countrySection);
    }

    // Collapse the company line field so you have to enable it
    if (company.length && !company.val().length) {
      companyContainer.hide();

      const addCompanyLink = $('<div class="mb-2"><a href="#"><i class="fa fa-plus-circle fa-fw"></i> Add school or company line...</a></div>');
      addCompanyLink.find('a').on('click', event => {
        event.preventDefault();
        companyContainer.fadeIn(150);
        addCompanyLink.remove();
        company.focus();
      });
      addCompanyLink.insertAfter(companyContainer);
    }

    country.on('change', event => {
      const countryValue = event.target.value;

      if (countryValue != "") {
        const spinnerTimeout = setTimeout(() => {
          afterCountry.addClass('loading-spinner-before');
        }, 200);

        const updateCountry = data => {
          clearTimeout(spinnerTimeout);
          afterCountry.removeClass('loading-spinner-before');

          subdivisionLabel.text(data.subdivision_label + (data.subdivision_required ? '*' : ''));
          postalCodeLabel.text('Postal code' + (data.is_postal_code_required ? '*' : ''));
          postalCode.attr('placeholder', data.is_postal_code_required ? '' : 'Optional');

          const subdivision = $item.find('[name$="subdivision"]');
          let newSubdivision;
          const lastValue = getSubdivision();

          if (data.subdivisions.length) {
            newSubdivision = $('<select class="form-control">');
            newSubdivision.append($('<option>')); // Empty option
            data.subdivisions.forEach(item => {
              const option = $('<option>');
              option.attr('value', item.alpha2);
              option.text(item.name);
              newSubdivision.append(option);
            });
          } else {
            newSubdivision = $('<input type="text" class="form-control">');
          }
          for (const key of ['id', 'name']) {
            newSubdivision.attr(key, subdivision.attr(key));
          }
          subdivision.replaceWith(newSubdivision);
          setSubdivision(lastValue);
        };

        $.ajax({
          method: 'get',
          url: `/ws/v1/countries/${countryValue}/`
        }).then(updateCountry, () => {
          // Make sure the form is still usable
          updateCountry({
            is_postal_code_required: false,
            subdivision_label: 'Province/State',
            subdivision_required: false,
            subdivisions: []
          })
        });
      }
    }).trigger('change');

    postalCode.on('change', event => {
      const countryValue = country.val();
      const postalCodeValue = event.target.value.replace(/^\s+|\s+$/g, '');

      if (countryValue != "" && postalCodeValue.match(/^[A-Za-z0-9 \-]+$/)) {
        citySuggestions = [];

        $.ajax({
          method: 'get',
          url: `/ws/v1/countries/${countryValue}/postal-codes/${postalCodeValue}/`
        }).then(data => {
          if (data.results.length) {
            citySuggestions = data.results.map(item => item.city_name);

            if (citySuggestions.length == 1) {
              city.typeahead('val', citySuggestions[0]);
            } else {
              const currentCityValue = city.typeahead('val');
              if (currentCityValue.length && citySuggestions.indexOf(currentCityValue) == -1) {
                city.typeahead('val', '');
              }
            }

            if (data.results[0].subdivision) {
              const subdivision = $item.find('[name$="subdivision"]');
              subdivision.val(data.results[0].subdivision.alpha2);
            }

            city.attr('autocomplete', 'off');
          } else {
            city.attr('autocomplete', '');
          }
        }, () => {
          city.attr('autocomplete', '');
        });
      }
    }).trigger('change');

    city.typeahead({
      minLength: 0,
      highlight: true
    }, {
      name: 'default',
      source: function (query, syncResults, asyncResults) {
        syncResults(citySuggestions);
      }
    });
  });
});